module.exports = __webpack_public_path__ + "media/facebook.c4c9def5.svg";